import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressService } from '../../service/address/address.service';
import { UtilsService } from '../../service/utils/utils.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SwalPortalTargets } from '@sweetalert2/ngx-sweetalert2';
import { State } from '../../domain/state';
import { City } from '../../domain/city';
import { Client } from '../../domain/client';
import { ClientService } from '../../service/client/client.service';
import { TimeoutError } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-update-client-address-form',
  templateUrl: './modal-update-client-address-form.component.html',
  styleUrls: ['./modal-update-client-address-form.component.css'],
})
export class ModalUpdateClientAddressFormComponent implements OnInit {
  constructor(
    private service: ClientService,
    private serviceAddress: AddressService,
    private utilsService: UtilsService,
    private fb: FormBuilder,
    public readonly swalTargets: SwalPortalTargets
  ) {}

  error: string = '';

  form: FormGroup;
  loading: boolean = false;
  messageError: string = '';
  states: State[] = [];
  cities: City[] = [];
  modalFireCondition: boolean = false;

  @Input() client: Client;

  @Output() modalConfirm: EventEmitter<Client> = new EventEmitter();

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      id: new FormControl(''),
      zipCode: new FormControl('', [Validators.maxLength(9)]),
      publicPlace: new FormControl('', [Validators.maxLength(100)]),
      neighborhood: new FormControl(''),
      cityId: new FormControl(null),
      stateId: new FormControl(null),
    });
  }

  onFormUpdate() {
    this.serviceAddress.getStates().subscribe(
      (data) => {
        this.states = data;
      },
      (error) => {
        error = 'Não foi possível Buscar os Estados!';
      }
    );

    if (this.client?.address?.city?.state?.id)
      this.fetchCities(this.client.address.city.state.id);

    const { id, zipCode, publicPlace, neighborhood, city } =
      this.client.address ?? {};
    this.form.patchValue({
      id,
      zipCode,
      publicPlace,
      neighborhood,
      cityId: city?.id,
      stateId: city?.state?.id,
    });
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    const {
      id,
      zipCode,
      publicPlace,
      neighborhood,
      cityId,
      requestAppRace,
      ...formData
    } = this.form.value;

    this.client.address = {
      ...this.client.address,
      zipCode: zipCode.replace(/[^0-9,.]+/g, ''),
      publicPlace,
      neighborhood,
    };

    this.client.address.cityId = +cityId;
    this.client.address.city.id = +cityId;

    this.loading = true;
    this.service.update(this.client).subscribe(
      (data) => {
        this.loading = false;
        this.modalConfirm.emit(data.body);
        this.form.reset();
        this.cities = [];
        this.states = [];

        this.modalFireCondition = false;
      },
      (error) => {
        this.loading = false;
        this.setErrors(error.error.errors);
      }
    );
  }

  setErrors(errors) {
    errors.forEach((err: any) => {
      this.form.get(err.fieldName)?.setErrors({ invalid: err.message });
      this.messageError += `${err.message}\n`;
    });
  }

  onBlurCep(event) {
    // event.target.value
    this.loading = true;

    if (event.target.value.replace(/[^0-9,.]+/g, '').length === 8) {
      this.utilsService
        .getCep(event.target.value.replace(/[^0-9,.]+/g, ''))
        .subscribe(
          (data) => {
            const viaCep = data;

            if (!viaCep.erro) {
              this.cities = [];

              this.form.get('neighborhood').patchValue(viaCep.bairro);
              this.form.get('publicPlace').patchValue(viaCep.logradouro);

              this.form.get('stateId').patchValue('');
              this.form.get('cityId').patchValue('');
              const state = this.states.find(
                (state) => state.initials === viaCep.uf.toUpperCase()
              );

              this.form.get('stateId').patchValue(state.id);

              // TODO - Implementar busca de cidades por UF
              this.serviceAddress.getCitiesByStateId(state.id).subscribe(
                (data) => {
                  this.cities = data;
                  const city = this.cities.find(
                    (elem) =>
                      elem.name.normalize('NFD') ===
                      viaCep.localidade
                        .toUpperCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                  );

                  if (city) {
                    this.form.get('cityId').patchValue(city.id);
                  }
                },
                (error) => {
                  error = 'Erro ao buscar cidades!';
                }
              );
            } else {
              this.form.controls.zipCode.setErrors({
                invalid: 'CEP não encontrado!',
              });
            }
            this.loading = false;
          },
          (err) => {
            if (err instanceof TimeoutError) {
              Swal.fire({
                title: 'Erro ao buscar os dados do endereço!',
                text: 'O Servidor de busca de endereços não respondeu!\nPor favor, preencha os dados de endereço manualmente.',
                icon: 'error',
                toast: false,
              });
              this.loading = false;
              return;
            }
            this.form.controls.zipCode.setErrors({
              invalid: 'CEP não encontrado!',
            });
            this.loading = false;
          }
        );
    } else {
      this.loading = false;
      this.form.controls.zipCode.setErrors({
        invalid: 'CEP inválido!',
      });
    }
  }

  onSelectedState(event) {
    if (event.target.value) {
      this.fetchCities(event.target.value);
    }
  }

  fetchCities(stateId: number) {
    this.loading = true;
    this.serviceAddress.getCitiesByStateId(stateId).subscribe(
      (data) => {
        this.cities = data;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        error = 'Erro ao buscar cidades!';
      }
    );
  }

  onClose() {
    this.form.reset();
    this.cities = [];
    this.states = [];

    this.modalFireCondition = false;
  }
}
